export default {
    routerName: '職位詳細',
    post: {
        name: '職位名',
        code: '職位番号',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
        remark: '備考',
    },
};
